import AddToPrivateCollectionButtonWithPopover from './AddToPrivateCollectionButtonWithPopover';
import AddToPrivateCollectionButtonWithPopoverContainer from './AddToPrivateCollectionButtonWithPopover.container';
export default AddToPrivateCollectionButtonWithPopoverContainer(AddToPrivateCollectionButtonWithPopover);
